<template>
  <section ref="wizcoSection" v-editable="props.blok" :data-uid="props.blok._uid">
    <ClientOnly fallback-tag="h1" :fallback="props.blok.title ?? 'Lade Fragebogen…'">
      <WizCo
        v-if="etData?.p4etoken || isNoLongerWaitingForEt"
        ref="wizco"
        :uuid="props.blok.wizardSettingsUuid"
        :tracking-token="etData.p4etoken ?? ''"
        :partner-id="route.query.partner_id ?? ''"
        :session-data="route.query.sessionData ?? null"
        @tracking-event="addTrackingEvent"
        @step-change="stepChangeEvent"
        @forward-request="onForwardRequest"
      />
      <PflegeSpinner
        v-else
        color="blue-light"
        :size="5"
      />
    </ClientOnly>

    <Teleport to="body">
      <PflegeModal v-model="showHintModal" :is-persistent="false" heading="Erneut starten: Bestätigen Sie Ihre Daten" show-closing>
        <p>Sie haben gerade eine Auswahl getroffen, bei der ein Schritt zurück nicht möglich ist.</p>
        <p>Um weiterzumachen, beginnen Sie den Antrag von vorne.</p>
        <template #actions>
          <PflegeButton label="Antrag neu starten" @click="showHintModal = false" />
        </template>
      </PflegeModal>
    </Teleport>
  </section>
</template>

<script setup>
import * as Sentry from '@sentry/browser'

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})

const route = useRoute()

const { disableExternalTracking, etData, trackDatalayer } = useTracking()
disableExternalTracking()

const showHintModal = shallowRef(false)
const addTrackingEvent = (response) => {
  if (!etData.value?.p4etoken) {
    Sentry.setContext('etData', etData.value)
    Sentry.captureMessage('WPBlockWizco: Could not pass trackingToken 2 WizCo')
  }
  //  There can be multiple event data passed
  if (response.length) {
    response.forEach((eventObject) => {
      trackDatalayer(eventObject)
    })
  }
}

const wizcoSectionRef = useTemplateRef('wizcoSection')
const stepChangeEvent = () => {
  wizcoSectionRef.value.scrollIntoView({ behavior: 'smooth' })
  setTimeout(() => {
    wizcoSectionRef.value.scrollIntoView({ behavior: 'smooth' })
  }, 500)
}

const onForwardRequest = (response) => {
  navigateTo(useCalcedLink({ link: response }), {
    external: true,
  })
}

const isNoLongerWaitingForEt = shallowRef(false)
const wizcoRef = useTemplateRef('wizco')
onMounted(() => {
  window.addEventListener('pageshow', (event) => {
    // page is loaded from back/forward cache of the browser
    if (event.persisted) {
      showHintModal.value = true
      wizcoRef.value.goToStart()
    }
  })
  setTimeout(() => {
    isNoLongerWaitingForEt.value = true
  }, 2000)
})
</script>

<style scoped lang="scss">
section {
  position: relative;
  z-index: 99;
  min-height: 20vh;

  & > .wizco {
    scroll-margin-top: 3.5rem;
  }

  & > .spinner,
  & > h1 {
    margin-block: 5rem;
    text-align: center;
  }
}
</style>
